// @flow

import { persistReducer } from "redux-persist";
import type { PersistConfig } from "redux-persist/lib/types";
import storage from "redux-persist/lib/storage";
import { SAVE_USER_DATA, CLEAR_USER_DATA, PASSWORD_REFRESHED } from "./actionTypes";

export const PERSIST_KEY = "user";

type SaveUserDataAction = {|
  type: typeof SAVE_USER_DATA,
  payload: {| token: string, email: string, passwordExpired: boolean |}
|};

type ClearUserDataAction = {|
  type: typeof CLEAR_USER_DATA
|};

type PasswordRefreshed = {|
  type: typeof PASSWORD_REFRESHED
|};

export type ActionUser = SaveUserDataAction | ClearUserDataAction | PasswordRefreshed;

export type StateUser = {|
  token: ?string,
  email: ?string,
  passwordExpired: ?boolean
|};

export const reducer = (
  state: StateUser = {
    token: null,
    email: null,
    passwordExpired: null
  },
  action: ActionUser
) => {
  switch (action.type) {
    case CLEAR_USER_DATA:
      return {
        token: null,
        email: null,
        passwordExpired: null
      };
    case SAVE_USER_DATA:
      return {
        ...state,
        ...action.payload
      };
    case PASSWORD_REFRESHED:
      return {
        ...state,
        passwordExpired: false
      };
    default:
      return state;
  }
};

const persistConfig: PersistConfig = {
  key: PERSIST_KEY,
  storage
};

// $FlowFixMe
export default persistReducer(persistConfig, reducer);
